var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"pt-1",attrs:{"md10":"","offset-md1":""}},[_c('v-form',{staticStyle:{"width":"100%"},on:{"submit":function($event){$event.preventDefault();return _vm.sendMessage($event)}}},[_c('v-text-field',{ref:"message",attrs:{"label":"Solo","placeholder":"Escreva sua mensagem","solo":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/chat/ChatBox.vue?vue&type=template&id=3d96e946&
// module id = 534
// module chunks = 1